import React from 'react';
import style from './style.module.scss';
import { DurationTable } from './DurationTable';
import { CustomersTable } from './CustomersTable';
import { AvgSpendBookingWrapper } from './AvgSpendBookingWrapper';

const NS = 'ReportingDetailsPage';

/** Renders tables and graphs on the dashboard */
export const ReportingDetailsPage = () => {
  return (
    <div className={style.bargraph}>
      <CustomersTable />
      <AvgSpendBookingWrapper />
      <DurationTable />
    </div>
  )
}